import { useId } from 'react';
import { CoinSummary } from './CoinPreview';
import { CoinIdentity } from './CoinIdentity';
import { previewBet } from './previewModel';
import type { ArtRenderer, CoinView } from './model';

export function ExploreCard({
  coin,
  now,
  art,
}: {
  coin: CoinView;
  now: number;
  art: ArtRenderer;
}) {
  const titleId = useId();
  const bet = previewBet(coin);
  return (
    <article
      className="explore-card"
      aria-labelledby={titleId}
      data-preview-state={bet?.result ?? (bet ? 'bet' : 'default')}
    >
      <CoinSummary
        coin={coin}
        now={now}
        layout="explore"
        header={
          <header className="coin-head explore-card-head">
            <div className="coin-headings">
              <CoinIdentity coin={coin} titleId={titleId} compact />
            </div>
            <div className="explore-art-wrap">{art(coin, 'explore-art')}</div>
          </header>
        }
      />
    </article>
  );
}
